module.exports = "<div class=\"container-fixed-lg full-height full-height-container\">\n    <chassis-form-builder [entityId]=\"entityId\" [formId]=\"formId\" [routePrefix]=\"routePrefix\"></chassis-form-builder>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/pages/entities/forms/edit/edit.page.html
// module id = ./libs/chassis-core/src/app/pages/entities/forms/edit/edit.page.html
// module chunks = main